import { Link } from "react-router-dom";
import { Dumbbell } from "lucide-react";
import { cn } from "@/lib/utils";

interface BrandLockupProps {
  ariaLabel?: string;
  className?: string;
  compact?: boolean;
  inverted?: boolean;
  to?: string;
}

export function BrandLockup({
  ariaLabel = "FitnessAppie",
  className,
  compact = false,
  inverted = false,
  to = "/",
}: BrandLockupProps) {
  return (
    <Link
      to={to}
      aria-label={ariaLabel}
      className={cn("inline-flex min-h-11 items-center gap-2.5", className)}
    >
      {inverted ? (
        <Dumbbell className={cn("shrink-0", compact ? "h-7 w-7" : "h-8 w-8")} aria-hidden />
      ) : (
        <img
          src="/app-icon.svg"
          alt=""
          width={compact ? 28 : 32}
          height={compact ? 28 : 32}
          className="shrink-0"
        />
      )}
      <span
        className={cn(
          "font-display font-bold leading-none",
          compact ? "text-base" : "text-lg",
          inverted ? "text-white" : "text-text",
        )}
      >
        FitnessAppie
      </span>
    </Link>
  );
}
